import { Tooltip as ReactTooltip } from 'react-tooltip'
import styled from 'styled-components'

import { theme } from '../../../theme'

export const Tooltip = styled(ReactTooltip)`
  background-color: ${theme.colors.purpleOde};
  color: ${theme.colors.white};
  font-size: 14px;
  padding: 14px;
  z-index: 10;
  transition-duration: 0.1ms;
  max-width: 220px;
  white-space: normal;
  text-align: center;
  opacity: 1;
  border-radius: 8px;
  font-weight: 400;
`

export const TooltipChildren = styled.span`
  white-space: normal;
`
